import type { Environments, Target } from "./types";

// Production is absent, which is the point. aws-int and aws-stg are here
// because that is what a devstack runs as - the pods carry a real environment
// and only the hostname says which devstack.
export const VALID_ENVS: Array<Environments> = [
  "dev",
  "local",
  "qa",
  "staging",
  "aws-int",
  "aws-stg"
];

/**
 * Where each environment lives, per brand.
 *
 * Taken from packages/tvg-lib-conf/content/<environment>/<brand>.ts, which is
 * what @tvg/conf serves the apps, so moving lands on the host the app would
 * have called itself. The local hosts are the ones the getting started guide
 * puts in /etc/hosts (apps-tooling/frontend-docs/docs/getting-started.md).
 *
 * Maps rather than object literals throughout: every key comes from a hostname
 * or a select, and a plain object would expose its prototype to it.
 */
export const HOSTS = new Map<string, Map<Target, string>>([
  [
    "tvg",
    new Map([
      ["local", "local-qa.tvg.com:8080"],
      ["qa", "www-qa.tvg.com"],
      ["staging", "www-staging.tvg.com"],
      ["production", "www.tvg.com"]
    ])
  ],
  [
    "iowa",
    new Map([
      ["local", "local-ia-qa.tvg.com:8080"],
      ["qa", "ia-qa.tvg.com"],
      ["staging", "ia-staging.tvg.com"],
      ["production", "ia.tvg.com"]
    ])
  ],
  [
    "pabets",
    new Map([
      ["local", "local-pa-qa.tvg.com:8080"],
      ["qa", "pabets-qa.tvg.com"],
      ["staging", "pabets-staging.tvg.com"],
      ["production", "pabets.tvg.com"]
    ])
  ],
  [
    "4njbets",
    new Map([
      ["local", "local-4njbets-qa.us.betfair.com:8080"],
      ["qa", "4njbets-qa.us.betfair.com"],
      ["staging", "4njbets-staging.us.betfair.com"],
      ["production", "4njbets.us.betfair.com"]
    ])
  ]
]);

// One devstack serves every brand, so a host prefix is all that picks one.
// Kept in step with packages/tvg-lib-conf/src/brand.ts, which is what actually
// decides the brand.
export const DEVSTACK_PREFIXES = new Map([
  ["iowa", "ia-"],
  ["pabets", "pa-"],
  ["4njbets", "nj-"]
]);

// Only QA and staging have a devstack, and these are the domains their
// ingresses publish: racing-traffic-splitter/infrastructure/k8s/helm/values/
// devstack-legacy.yaml and devstack-legacy-stg.yaml.
export const DEVSTACK_DOMAINS = new Map<Target, string>([
  ["qa", "dev-qa.tvg.com"],
  ["staging", "dev-staging.tvg.com"]
]);

export const DEVSTACK_LABEL = "devstack-";

// Bookkeeping in the devstack name that a developer does not need to read:
// the name is legacy-<branch> in QA and legacy-stg-<branch> in staging.
export const NAME_PREFIXES = ["legacy-", "stg-"];

export const TARGETS: Array<{ label: string; value: Target }> = [
  { label: "Local", value: "local" },
  { label: "QA", value: "qa" },
  { label: "Staging", value: "staging" },
  { label: "Production", value: "production" }
];
